import React, { useState, useEffect } from "react";


import "devextreme/data/odata/store";
import { useDispatch, useSelector } from "react-redux";
import CustomStore from "devextreme/data/custom_store";
import Request from "../../../components/api/Request";
import { TreeList, FilterRow, Selection, SearchPanel, Column, RowDragging, Editing,EditingState } from 'devextreme-react/tree-list';

import * as AppActions from '../../../actions/AppActions';
//import DomainDetay from "./DomaineDetay";
import { Popup } from 'devextreme-react/popup';
import { Button } from 'devextreme-react/button';
import { custom } from 'devextreme/ui/dialog';
import FileUploader from 'devextreme-react/file-uploader';
import { ToastType } from "../../../constants/Constants";
import { showToast, parseDate, hasRole } from "../../../utils/Utils";
import DataSource from 'devextreme/data/data_source'; 
import ArrayStore from 'devextreme/data/array_store';

const KullaniciDomain = (props) => {
    const dispatch = useDispatch();

    const [formYetki, setFormYetki] = useState(
        {
            listele: hasRole("tanimlar|kullanici|listele"),    
            goruntule: hasRole("tanimlar|kullanici|goruntule"),  
            ekle: hasRole("tanimlar|kullanici|ekle"),  
            degistir: hasRole("tanimlar|kullanici|degistir"),  
            sil: hasRole("tanimlar|kullanici|sil"),  
            domainList: hasRole("tanimlar|kullanici|domainList"),    
            roleList: hasRole("tanimlar|kullanici|roleList"),    
            userDomainSave: hasRole("tanimlar|kullanici|userDomainSave"),    
            userRoleSave: hasRole("tanimlar|kullanici|userRoleSave")
        });

    const [store, setStore] = useState(null);
    const [domainDetail, setDomainDetail] = useState();
    const dataSource = new DataSource({
        store: new ArrayStore({
            data: domainDetail,
            key: 'id'
        })
    });


    useEffect(() => {
        loadDomainDetail();
    }, []);

    const loadDomainDetail = () => {
        const request = new Request("/kullanici/getKullaniciDomainList/" + props.data.id, "GET");

        return request.run()
            .then(response => {
                if (response.data) {
                    setDomainDetail(response.data.data)
                }
            });
    }

  
    function kaydet(e) {
        
        let data = domainDetail;

        let method = "POST"
        let url = "/kullanici/saveKullaniciDomainList/" + props.data.id;

        const request = new Request(url, method, data);
        dispatch(AppActions.setLoading(true, "Kayıt işlemi yapılıyor.."));
        return request.run()
            .then(response => {
                dispatch(AppActions.setLoading(false, ""));
                if (response.data && response.data.data) {
                    props.hide();
                }
            });

    }

    function yetkiSec(e) {
        if(e.columnIndex == 1){
            let id = e.data.id;    
            let data = domainDetail;

            data.map(d => {
                if(d.parentId == id){
                    d.enable =e.value;
                    data.map(d2 => {
                        if(d2.parentId == d.id){
                            d2.enable =e.value;
                        }
                    });
                }
            });
            setDomainDetail(data);
        }        
    }

    

 

    return (
        <div> 
            <TreeList
                id="menus"
                className="kullaniciDomainTree"
                rootValue={null}
                dataSource={dataSource}
                showBorders={true}
                columnHidingEnabled={true}
                columnAutoWidth={true}
                showRowLines={true}
                defaultExpandedRowKeys={[1]}
                keyExpr={"id"}
                parentIdExpr={"parentId"}
                onCellClick ={(e) => { yetkiSec(e); }}

            >
        
                  <Editing
                    mode="cell"
                    allowUpdating={true}
                    startEditAction="click"
                    // onEditRowKeyChange={onEditRowKeyChange}
                    // onChangesChange={onChangesChange}
                />
                <Selection mode="single" />
                <FilterRow visible={true} /> 
                <Column dataField="name" caption="Adı" width={300} defaultSortOrder="asc"  allowEditing={false}  />
                <Column dataField="enable" caption="Yetki" width={90} allowEditing={true}  />
            </TreeList>

            <Button
                width={1000}
                text="Save"
                type="success"
                stylingMode="contained"
                visible={formYetki.userDomainSave}
                onClick={kaydet}
            />
        </div>
    );
};

export default KullaniciDomain;
